export const getDoctorHolidayData = (store) => store.doctorHolidayForm.editData;
export const getAreaList = (store) => store.doctorHolidayForm.filters.area;
export const getConsultList = (store) =>
  store.doctorHolidayForm.filters.consult;
